import { useAiApiClient } from "#lib/AiApiClient.ts";
import { AiMutationKeys, AiQueryKeys } from "#lib/AiQueryKeys.ts";
import type { UpdatePersonalizationCommand } from "#types/types.ts";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useUpdatePersonalizationMutation = () => {
    const { updatePersonalization } = useAiApiClient();
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: AiMutationKeys.UpdatePersonalization(),
        mutationFn: async (payload: UpdatePersonalizationCommand) => {
            await updatePersonalization(payload);
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: AiQueryKeys.GetPersonalization() });
        }
    });
};
